import { defineStore } from 'pinia'
import { type TPage } from '~/types/page-types'
import { TDomain } from '~/types/other-types'

type TStoreState = {
  domain: TDomain | undefined;
};

export const useDomainStore = defineStore('domains', {
  state: (): TStoreState => {
    return {
      domain: undefined
    }
  },
  actions: {
    setCurrentDomain (data: TPage) {
      this.$state.domain = data.domain && data.domain.color ? data.domain.color.name : undefined
    }
  },
  getters: {
    getCurrentDomain: state => state.domain
  }
})
